import { SvgIconProps } from "@mui/material";
import { StyledSvgIconWithContrastStroke } from "./StyledSvgIcon";

export default ({ ...props }: SvgIconProps) => (
  <StyledSvgIconWithContrastStroke
    height="24px"
    viewBox="0 0 100 100"
    width="24px"
    {...props}
  >
    <rect
      width="54"
      height="85"
      x="23"
      y="7"
      rx="3"
      ry="3"
      fill="#f00"
      strokeWidth="0.5"
      stroke="#000"
    />
    <path
      fill="inherit"
      stroke={"inherit"}
      transform="scale(2.5,2.5)"
      d="M9 1h6v2H9zm10.03 6.39 1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61M13 14h-2V8h2z"
    />
  </StyledSvgIconWithContrastStroke>
);
